import React from "react";

export default function Footer() {
  return (
    <div className="bg-primary flex justify-center items-center h-16 text-white pb-2">
      Copyright @2024 Accelist Technology
    </div>
  );
}
